import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import {
  LoadingProgressComponent,
  LoadingStep,
} from '../../../../../common/components/loading-progress/loading-progress';
import { THEME_COLOR } from '../../services/lesson-plan.models';

@Component({
  selector: 'app-step-structure-loading',
  standalone: true,
  imports: [LoadingProgressComponent],
  template: `
    <app-loading-progress
      [title]="title"
      [subtitle]="subtitle"
      [tipText]="tipText"
      [themeColor]="themeColor"
      [steps]="steps"
    ></app-loading-progress>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepStructureLoadingComponent {
  @ViewChild(LoadingProgressComponent) loadingComponent?: LoadingProgressComponent;

  protected readonly themeColor = THEME_COLOR;
  protected readonly title = 'Building your lesson plan';
  protected readonly subtitle = 'Creating an engaging structure based on your objectives.';
  protected readonly tipText =
    "We're designing activities that align with your learning objectives.";

  protected readonly steps: LoadingStep[] = [
    { id: 1, label: 'Analyzing selected objectives...' },
    { id: 2, label: 'Reviewing uploaded materials...' },
    { id: 3, label: 'Designing lesson phases...' },
    { id: 4, label: 'Allocating time for activities...' },
    { id: 5, label: 'Creating engaging activities...' },
    { id: 6, label: 'Finalizing lesson structure...' },
  ];

  /**
   * Complete the progress (called externally when structure is ready).
   */
  complete(): void {
    this.loadingComponent?.complete();
  }
}
